import React, { useEffect, useRef, useState } from 'react';

const OtpField = (props) => {
  const [state, setState] = useState({
    value: props.value,
    error: props.error,
    enableLink: false,
  });
  const [secondCount, setSecondCount] = useState<any>(30);
  const [minuteCount, setMinuteCount] = useState<any>(0);
  let secondsRemaining: any = 0;
  const intervalHandle = useRef(null);

  const tick = () => {
    let min = Math.floor(secondsRemaining / 60);
    let sec = secondsRemaining - min * 60;
   setMinuteCount(min);
   setSecondCount(sec);
    if (sec < 10) {
      setSecondCount('0' + setSecondCount);
    }
    if (min < 10) {
      setMinuteCount('0' + min)
    }
    if ((min === 0) && (sec === 0)) {
      clearInterval(intervalHandle.current);
      setState({ ...state, enableLink: true });
    }
    secondsRemaining--;
  };

  const resetTimer = () => {
    props.getOtp();
    setState(
      { ...state, enableLink: false },
    );
    return () => {
      intervalHandle.current = setInterval(tick, 1000);
      secondsRemaining = (minuteCount * 60) + secondCount;
    }
  };

  const handleInput = (event) => {
    const value = event.target.value.trim();
    setState({ ...state, value });
  };

  const changeValue = (event) => {
    props.changeValue(event.target.value.trim());
  };

  useEffect(() => {
    intervalHandle.current = setInterval(tick, 1000);
    secondsRemaining = ( minuteCount * 60 ) + secondCount;

    return () => {
      clearInterval(intervalHandle.current);
    };
  }, []);

    const { placeholder, errorMsg, label, resendOtpText, resendText } = props;
    const { error, value } = state;
    return (
      <div
        className={`makeFlex column otpFieldcontainer ${
          error ? 'errorField' : ''
        }`}
      >
        <label className="latoBold appendBottom15 font14 defaultGreyText">
          {label}
        </label>
        <input
          value={value}
          type="text"
          placeholder={placeholder}
          className={'otpField'}
          onBlur={changeValue}
          onInput={handleInput}
        />
        <span className="font12 errorText">{errorMsg}</span>
        <p
          className={`latoBold font14 appendTop20 resendLink ${
            state.enableLink ? '' : 'disabled'
          }`}
        >
          <a
            onClick={resetTimer}
          >{state.enableLink ? resendText : `${resendOtpText} ${minuteCount}m:${secondCount}s`}</a>
        </p>
      </div>
    );
  }

  export default OtpField;
